import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { format, startOfMonth, parseISO } from 'date-fns';
import './EventListSidebar.css';

const EventListSidebar = ({ events }) => {
  const [searchParams] = useSearchParams();
  const now = new Date();
  const startOfCurrentMonth = startOfMonth(now);

  const upcomingEvents = events.filter(event => event.date && event.date >= startOfCurrentMonth);
  const sortedEvents = upcomingEvents.sort((a, b) => a.date - b.date);

  const groupedEvents = sortedEvents.reduce((acc, event) => {
    const monthKey = format(event.date, 'yyyy-MM');
    if (!acc[monthKey]) acc[monthKey] = [];
    acc[monthKey].push(event);
    return acc;
  }, {});

  return (
    <div className="sidebar-container">
      <h3 className="sidebar-events-header">Upcoming Events</h3>
      <div className="sidebar-list-wrapper">
        {Object.keys(groupedEvents).length > 0 ? (
          Object.keys(groupedEvents).map(monthKey => (
            <div key={monthKey} className="sidebar-group">
              <h4 className="sidebar-group-header">
                {format(parseISO(`${monthKey}-01`), 'MMMM yyyy')}
              </h4>
              <ul className="sidebar-list">
                {groupedEvents[monthKey].map(event => (
                  <Link 
                    key={event.id} 
                    to={`/events/${event.slug}?${searchParams.toString()}`} 
                    className="sidebar-event-item"
                  >
                    <div className="event-item-header">
                      <div className="event-item-title">{event.title}</div>
                      {event.category_details && (
                        <span 
                          className="event-category-pill" 
                          style={{ 
                            backgroundColor: event.category_details.color,
                            color: '#fff',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '0.75rem',
                            marginLeft: '8px',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {event.category_details.icon} {event.category_details.name}
                        </span>
                      )}
                    </div>
                    <div className="event-item-location">{event.city}, {event.country}</div>
                  </Link>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <p className="sidebar-no-events">No upcoming events match the current filters.</p>
        )}
      </div>
    </div>
  );
};

export default EventListSidebar;